import { _err, _log } from './logger';
import { randomNumber, ratioHeight, toBase64 } from './util';
import store from '../store';

export default class IFabric {
  static store;
  id;
  origX;
  origY;
  typeShape;
  objects = [];

  constructor(canvasF, callback, stream) {
    this.id = Date.now() + Math.random();
    this.canvasF = canvasF;
    this.stream = stream;
    this.mainOverlay;
    this.obj = {};
    this.callback = callback;
    this.isMouseDown = false;
    this.translatedPoints = {};
    this.faceHide;
    this.isFillable = true;
    this.canvasF.set({ isDrawingMode: false });
  }

  addEffect(o, filterEffect, active, options) {
    o.faceFilter = null;
    o.faceDistort = null;
    o.faceZoom = null;

    if (active) {
      if (o.setCanvasElement) {
        o.setCanvasElement();
      }
      if (o.setEffect) {
        o.setEffect(filterEffect, options);
      }
    }
  }

  selectionMask() {
    //_log("selectionMask()")
    const ao = this.getActiveObjects();
    const clip = ao[1];
    const o = ao[0];
    if (clip && o) {
      clip.absolutePositioned = true;
      o.absolutePositioned = true;
      o.set('clipPath', clip);
      this.canvasF.bringToFront(o);
      // this.canvasF.remove(clip)
    }
  }

  selectionBack() {
    //_log("selectionBack()")
    const ao = this.getActiveObjects();
    for (const o of ao) {
      this.canvasF.sendBackwards(o);
    }
  }
  selectionFront() {
    //_log("selectionFront()")
    const ao = this.getActiveObjects();
    for (const o of ao) {
      this.canvasF.bringForward(o);
    }
  }
  selectionFlip() {
    const ao = this.getActiveObjects();
    for (const o of ao) {
      let _flipX = o.flipX;
      if (_flipX === undefined) {
        _flipX = true;
      }
      o.flipX = !_flipX;
    }
  }

  selectionCopy() {
    const ao = this.getActiveObjects();
    for (const o of ao) {
      o.clone((cloned) => {
        // cloned.left += Math.random() 10;
        // cloned.top += 10;
        this.canvasF.add(cloned);
      });
    }
  }

  lastSelectionCopy() {
    const ao = this.getActiveObjects();
    if (!ao || ao.length < 1) {
      const objects = this.canvasF.getObjects();
      const top = objects[objects.length - 1];
      if (!top) {
        ao = [];
      } else {
        ao = [top];
      }
    }
    if (!ao || ao.length > 0) {
      ao[0].clone((cloned) => {
        cloned.left += 50;
        cloned.top += 50;
        this.canvasF.add(cloned);
        this.selectLastActiveObject();
        setTimeout(() => {
          this.styleSelection();
        }, 0);
      });
    }
  }

  setSelection(value) {
    this.canvasF.set('selection', value);
    //if (this.mainOverlay) this.mainOverlay.setSelection(value);
  }

  static setStore = (store) => {
    //_log("setStore", store)
    IFabric.store = store;
  };

  initSplit(active, options) {
    this.mainOverlay.initSplit(active, options);
  }

  removeAddListeners() {
    this.objects.forEach((o) => {
      o.remove();
    });
    this.objects = [];
  }

  toImage() {
    this.obj = new fabric.Image(this.obj.toDataURL(), {
      ...this.obj,
      objecttype: 'image',
    });
    return this.obj;
  }

  enableZoom() {
    this.canvasF.on('mouse:wheel', (opt) => {
      let delta = opt.e.deltaY;
      let zoom = this.canvasF.getZoom();
      let x = opt.e.offsetX;
      let y = opt.e.offsetY;
      //_log("enableZoom()", opt.e.offsetY, zoom)
      zoom *= 0.999 ** delta;
      if (zoom > 20) {
        zoom = 20;
      }
      if (zoom < 0.01) {
        zoom = 0.01;
        // x = this.canvasF.width / 2
        // y = this.canvasF.height / 2
      }
      //this.canvasF.zoomToPoint({ x: this.canvasF.width / 2, y: this.canvasF.height / 2 }, zoom);
      this.canvasF.zoomToPoint({ x, y }, zoom);

      opt.e.preventDefault();
      opt.e.stopPropagation();
    });
  }

  setTypeShape(typeShape) {
    //_log("setTypeShape", typeShape)
    this.typeShape = typeShape;
    this.canvasF.isDrawingMode = false;
    this.removeAddListeners();
    //_log("setTypeShape", this.typeShape)
    if (this.typeShape !== '---' && this.typeShape !== 'layer') {
      this.canvasF.set({ selection: false });
      this.canvasF.discardActiveObject();
      const ao = this.canvasF.getObjects();
      if (ao) {
        ao.forEach((o) => {
          o.set({ selectable: false });
        });
      }
      if (this.typeShape === 'line') {
        const line = this.newLine();
        line.add();
        this.objects.push(line);
      } else if (this.typeShape === 'square') {
        const rect = this.newRect();
        rect.add();
        this.objects.push(rect);
      }
      if (this.typeShape === 'circle') {
        const circle = this.newCircle();
        circle.add();
        this.objects.push(circle);
      } else if (this.typeShape === 'triangle') {
        const triangle = this.newTriangle();
        triangle.add();
        this.objects.push(triangle);
      } else if (this.typeShape === 'polygon') {
        const polygon = this.newPolygon();
        polygon.add();
        this.objects.push(polygon);
      } else if (this.typeShape === 'brush' || this.typeShape === 'eraser') {
        this.canvasF.isDrawingMode = true;
        this.brush = this.newBrush();
        this.brush.add();
        this.objects.push(this.brush);
      } else if (this.typeShape === 'text') {
        const text = this.newText();
        text.add();
        this.objects.push(text);
      }
    } else {
      this.setSelectable();
    }
  }

  setSelectable = () => {
    this.canvasF.set({ selection: true });
    //this.removeAddListeners()
    const ao = this.canvasF.getObjects();
    if (ao) {
      ao.forEach((o) => {
        o.set({ selectable: true });
      });
    }
    this.selectLastActiveObject();
  };

  discardActiveObject = () => {
    this.canvasF.discardActiveObject();
  };

  selectLastActiveObject = () => {
    //_log("selectLastActiveObject")
    let lastItem = 0;
    let objs = this.canvasF.getObjects();
    if (objs && objs.length > 1) {
      lastItem = objs[objs.length - 1];
    }
    if (lastItem && lastItem.objecttype !== 'mainOverlay') {
      this.canvasF.setActiveObject(lastItem);
    } else {
      lastItem = this.canvasF.item(1);
      if (lastItem && lastItem.objecttype !== 'mainOverlay') {
        this.canvasF.setActiveObject(lastItem);
      }
    }
  };

  updateActive = (updateItem) => {
    _log('updateActive', updateItem);
    const ao = this.canvasF.getActiveObjects() || [];
    if (ao && ao.length > 0) {
      //_log("update", ao)

      ao.forEach((o) => {
        if (updateItem === 'drawWidth') {
          o.set({
            strokeWidth: IFabric.store.drawWidth,
            // stroke: this.getStrokeColor(o),
          });
        } else if (updateItem === 'color_fill') {
          o.set({ fill: this.getFillColor(o) });
        } else if (updateItem === 'color_stroke') {
          o.set({ stroke: this.getStrokeColor(o) });
        } else if (updateItem === 'color_shadow') {
          o.set({ stroke: this.getStrokeColor(o) });
        } else if (updateItem === 'drawOpacity') {
          // if (o.objecttype === 'image') {
          //   o.set('opacity', IFabric.store.opacityImage);
          // } else {
          // }
          o.set({ opacity: IFabric.store.drawOpacity });
        } else if (updateItem === 'drawStrokeDash') {
          o.set({
            strokeDashArray: IFabric.store.isDrawStrokeDash
              ? [...IFabric.store.drawStrokeDash]
              : null,
          });
        } else if (updateItem === 'drawStrokeLineCap') {
          o.set({
            strokeLineCap: IFabric.store.drawStrokeLineCap,
            strokeLineJoin: drawStrokeLineCap,
            strokeUniform: IFabric.store.isScaleStroke,
          });
        } else {
          if (o.objecttype === 'text') {
            if (IFabric.store.drawTextStyle !== '---') {
              o.set('fontStyle', IFabric.store.drawTextStyle);
            }
            if (IFabric.store.drawTextAlign !== '---') {
              o.set('textAlign', IFabric.store.drawTextAlign);
            }
            if (IFabric.store.drawTextLine !== '---') {
              o.set(IFabric.store.drawTextLine, true);
            } else {
              o.set('underline', false);
              o.set('linethrough', false);
              o.set('overline', false);
            }
            if (IFabric.store.drawFontFamily) {
              o.set('fontFamily', IFabric.store.drawFontFamily);
            }
            if (IFabric.store.drawFontSize) {
              o.set('fontSize', IFabric.store.drawFontSize);
            }
          }
        }
        // if (updateItem === 'drawColor') {
        //   o.set({ fill: this.getFillColor(o) });
        // }
        // o.set({
        //   strokeWidth: IFabric.store.drawWidth,
        //   stroke: this.getStrokeColor(o),
        //   opacity: IFabric.store.drawOpacity,
        //   strokeLineCap: IFabric.store.drawStrokeLineCap,
        //   strokeLineJoin: IFabric.store.drawStrokeLineCap,
        //   fill: this.getFillColor(o),
        //   strokeUniform: IFabric.store.isScaleStroke,
        //   strokeDashArray: IFabric.store.isDrawStrokeDash
        //     ? [...IFabric.store.drawStrokeDash]
        //     : null,
        // });

        //_log("o.objecttype", o.objecttype)
      });
      this.render();
    }
  };

  getActiveObjects = () => {
    let ao = this.canvasF.getActiveObjects() || [];
    // if (ao.length === 0) {
    //   ao = [window.mainOverlay];
    // }
    return ao;
  };

  getCanvas = () => {
    return this.canvasF;
  };

  add = (obj) => {
    log('add');
    this.canvasF.add(obj);
  };
  remove = (obj) => {
    //_log("remove")
    this.canvasF.remove(obj);
  };

  getShadow = () => {
    return new fabric.Shadow({
      color: IFabric.store.drawShadowColor,
      blur: IFabric.store.drawShadowBlur,
      offsetX: IFabric.store.drawShadowX,
      offsetY: IFabric.store.drawShadowY,
    });
  };

  getActiveObjects() {
    return this.activeObjects();
  }

  updateActiveShadow = (
    drawShadowColor,
    drawShadowBlur,
    drawShadowX,
    drawShadowY
  ) => {
    const ao = this.canvasF.getActiveObjects() || [];
    //_log("update", ao)
    if (ao && ao.length > 0) {
      const shadow = new fabric.Shadow({
        color: drawShadowColor,
        blur: drawShadowBlur,
        offsetX: drawShadowX,
        offsetY: drawShadowY,
      });
      ao.forEach((o) => {
        o.set({ shadow });
      });
      this.render();
    }
  };

  removeActive = () => {
    const ao = this.canvasF.getActiveObjects() || [];
    //this.canvasF.discardActiveObject()
    //_log("update", ao)
    if (ao && ao.length > 0) {
      ao.forEach((o) => {
        // if (o.objecttype === "image_copy") {
        //     this.canvasF.remove(o)
        // }
        this.canvasF.remove(o);
      });
      this.render();
    }
  };

  removeAll = () => {
    const ao = this.canvasF.getObjects();
    this.canvasF.discardActiveObject();
    //_log("update", ao)
    if (ao) {
      ao.forEach((o) => {
        this.canvasF.remove(o);
      });
      this.render();
    }
  };

  removeLast = () => {
    const ao = this.canvasF.getObjects();
    if (ao && ao.length > 0) {
      this.canvasF.remove(ao.reverse()[0]);
      this.render();
    }
  };

  add = (e) => {
    //_log("add")

    this.canvasF.on('mouse:move', this.mMove);
    this.canvasF.on('mouse:down', this.mDown);
    this.canvasF.on('mouse:up', this.mUp);
  };

  remove = () => {
    //_log("remove")
    this.canvasF.off('mouse:move', this.mMove);
    this.canvasF.off('mouse:down', this.mDown);
    this.canvasF.off('mouse:up', this.mUp);
  };

  render = () => {
    //_log("render")
    this.canvasF.requestRenderAll();
  };

  mDown = (e) => {
    //this.canvasF.discardActiveObject()

    this.isMouseDown = true;
    const { x, y } = this.canvasF.getPointer(e);
    this.origX = x;
    this.origY = y;
    this._mDown(x, y);
    this.render();
  };

  mMove = (e) => {
    if (!this.isMouseDown) return;

    const { x, y } = this.canvasF.getPointer(e);
    this._mMove(x, y);
    this.render();
  };

  styleSelection = () => {
    if (!this.obj || typeof this.obj.set !== 'function') return;
    this.obj.set({
      transparentCorners: false,
      cornerColor: '#0d6efd',
      cornerStrokeColor: '#ddd',
      borderColor: '#ccc',
      cornerSize: 16,
      padding: 8,
      cornerStyle: 'circle',
      // borderDashArray: [3, 3]
    });
  };

  mUp = (e) => {
    this.isMouseDown = false;
    const { x, y } = this.canvasF.getPointer(e);
    this._mUp(x, y);
    //this.remove()
    if (this.callback) {
      this.callback(this.obj);
    }
    if (this.obj && this.obj.objecttype !== 'brush') {
      this.styleSelection();
    }
  };

  getObj = () => {
    return this.obj;
  };

  getStrokeColor = (o = { width: 100, height: 100 }) => {
    let result;
    if (IFabric.store.strokePattern && IFabric.store.strokePattern.img) {
      result = new fabric.Pattern({
        source: IFabric.store.strokePattern.img,
        repeat: 'repeat',
      });
    } else if (IFabric.store.strokeGradient) {
      //_log("IFabric.store.strokeGradient", IFabric.store.strokeGradient)
      result = new fabric.Gradient({
        type: IFabric.store.strokeGradient.type,
        coords: this.calcAngle(
          o,
          IFabric.store.strokeGradient.angle,
          IFabric.store.strokeGradient.type
        ),
        colorStops: IFabric.store.strokeGradient.colorStops,
      });
      //_log("strokeGradient result", result)
    } else {
      result = IFabric.store.drawStrokeColor;
    }
    return result;
  };
  getStrokeColorFrame = (o = { width: 100, height: 100 }) => {
    let result;
    if (IFabric.store.fillPatternFrame && IFabric.store.fillPatternFrame.img) {
      result = new fabric.Pattern({
        source: IFabric.store.fillPatternFrame.img,
        repeat: 'repeat',
      });
    } else if (IFabric.store.fillGradientFrame) {
      //_log("IFabric.store.strokeGradient", IFabric.store.fillGradientFrame)
      result = new fabric.Gradient({
        type: IFabric.store.fillGradientFrame.type,
        coords: this.calcAngle(
          o,
          IFabric.store.fillGradientFrame.angle,
          IFabric.store.fillGradientFrame.type
        ),
        colorStops: IFabric.store.fillGradientFrame.colorStops,
      });
      //_log("strokeGradient result", result)
    } else {
      result = IFabric.store.drawStrokeColorFrame;
    }
    return result;
  };

  calcAngle = (o, angle = 0, type) => {
    const { width, height } = o;
    let angleCoords;
    if (type == 'radial') {
      const num = height / 2;
      const radius = height + width / 4;
      let x = width / 2;
      let y = height / 2;

      if (angle === 'circle at center') {
      }
      if (angle === 'circle at right') {
        x = height;
        y = height / 2;
      } else if (angle === 'circle at left') {
        x = 0;
        y = height / 2;
      } else if (angle === 'circle at right top') {
        x = height;
        y = 0;
      } else if (angle === 'circle at left top') {
        x = 0;
        y = 0;
      } else if (angle === 'circle at right bottom') {
        x = height;
        y = height;
      } else if (angle === 'circle at left bottom') {
        x = 0;
        y = height;
      } else if (angle === 'circle at center top') {
        x = height / 2;
        y = 0;
      } else if (angle === 'circle at center bottom') {
        x = height / 2;
        y = height;
      }

      angleCoords = {
        r1: radius,
        r2: width * 0.05,

        x1: x,
        y1: y,

        x2: x,
        y2: y,
      };
    } else {
      const anglePI = angle * (Math.PI / 180);
      angleCoords = {
        x2: (Math.round(50 + Math.sin(anglePI) * 50) * width) / 100 || 0,
        x1:
          (Math.round(50 + Math.sin(anglePI + Math.PI) * 50) * width) / 100 ||
          0,
        y1: (Math.round(50 + Math.cos(anglePI) * 50) * height) / 100 || 0,
        y2:
          (Math.round(50 + Math.cos(anglePI + Math.PI) * 50) * height) / 100 ||
          0,
      };
    }

    return angleCoords;
  };

  getFillColor = (o = { width: 100, height: 100 }) => {
    let result;
    if (IFabric.store.fillPattern && IFabric.store.fillPattern.img) {
      result = new fabric.Pattern({
        source: IFabric.store.fillPattern.img,
        repeat: 'repeat',
      });
    } else if (IFabric.store.fillGradient) {
      //_log("IFabric.fill.strokeGradient", IFabric.store.fillGradient)
      result = new fabric.Gradient({
        type: IFabric.store.fillGradient.type,
        coords: this.calcAngle(
          o,
          IFabric.store.fillGradient.angle,
          IFabric.store.fillGradient.type
        ),
        colorStops: IFabric.store.fillGradient.colorStops,
      });
      //_log("fillGradient result", result)
    } else {
      result = IFabric.store.drawColor;
      //_log("fillGradient result", result)
    }
    return result;
  };

  newLine = (callback) => {
    //_log("newLne")
    return new FabricLine(this.canvasF, callback, IFabric.store);
  };
  newText = (callback) => {
    //_log("newText")
    return new FabricText(this.canvasF, callback, IFabric.store);
  };
  newBrush = (callback) => {
    //_log("newBrush")
    return new FabricBrush(this.canvasF, callback, IFabric.store);
  };
  newRect = (callback) => {
    //_log("newRect")
    return new FabricRect(this.canvasF, callback, IFabric.store);
  };
  newCircle = (callback) => {
    //_log("newCircle")
    return new FabricCircle(this.canvasF, callback, IFabric.store);
  };
  newTriangle = (callback) => {
    //_log("newTriangle")
    return new FabricTriangle(this.canvasF, callback, IFabric.store);
  };
  newPolygon = (callback) => {
    //_log("newPolygon")

    return new FabricPolygon(this.canvasF, callback, IFabric.store);
  };
  newImage = (file, filterCSS, filters, callback, isCopy, isModel) => {
    //_log("newImage")
    return new FabricImage(this.canvasF, callback, file, filterCSS, filters);
    //return new FabricImageMedia(this.canvasF, callback, file, filterCSS, filters, isCopy, isModel)
  };
  newModel = (file, filterCSS, filters, callback, isCopy, isModel) => {
    //_log("newImage")
    //return new FabricImage(this.canvasF, callback, file, filterCSS, filters)
    return new FabricModelMedia(
      this.canvasF,
      callback,
      file,
      filterCSS,
      filters,
      isCopy,
      isModel
    );
  };
  newGif = (file, filterCSS, filters, callback) => {
    //_log("newImage")
    if (isMediaStreamTrackProcessor) {
      return new FabricGif(this.canvasF, callback, file, filterCSS, filters);
    } else {
      return new FabricImage(this.canvasF, callback, file, filterCSS, filters);
    }
  };
  newVideo = (file, filterCSS, filters, callback, isCopy) => {
    //_log("newVideo")
    return new FabricVideo(
      this.canvasF,
      callback,
      file,
      filterCSS,
      filters,
      isCopy
    );
  };
  newVideoOverlay = (stream, callback) => {
    //_log("newVideo")
    return new FabricVideoOverlay(this.canvasF, stream, callback);
  };
}

export class FabricLine extends IFabric {
  constructor(canvasF, callback) {
    super(canvasF, callback);
  }

  _mUp = (x, y) => {
    this.obj.setCoords();
  };

  _mMove = (x, y) => {
    this.obj.set({
      x2: x,
      y2: y,
    });
  };

  _mDown = (x, y) => {
    this.id = `${x + y}`;

    const shadow = this.getShadow();
    //_log("fabric.Line", IFabric.store)
    this.obj = new fabric.Line([x, y, x, y], {
      id: this.id,
      stroke: this.getStrokeColor(),
      strokeWidth: IFabric.store.drawWidth,
      strokeLineCap: IFabric.store.drawStrokeLineCap,
      opacity: IFabric.store.drawOpacity,
      strokeUniform: IFabric.store.isScaleStroke,
      strokeDashArray: IFabric.store.isDrawStrokeDash
        ? IFabric.store.drawStrokeDash
        : null,
      selectable: false,
      shadow,
    });
    this.obj.typeShape = 'line';
    this.obj.isNotFillable = true;
    this.canvasF.add(this.obj);
  };
}

export class FabricRect extends IFabric {
  constructor(canvasF, callback) {
    super(canvasF, callback);
  }

  _mUp = (x, y) => {
    this.obj.setCoords();
  };

  _mMove = (x, y) => {
    this.obj.set({ left: Math.abs(this.origX > x ? x : this.origX) });
    this.obj.set({ top: Math.abs(this.origY > y ? y : this.origY) });
    this.obj.set({ width: Math.abs(this.origX - x) });
    this.obj.set({ height: Math.abs(this.origY - y) });
  };

  _mDown = (x, y) => {
    this.id = `${x + y}`;

    const shadow = this.getShadow();
    //_log("fabric.Rect", IFabric.store)
    this.obj = new fabric.Rect({
      id: this.id,
      top: x,
      left: y,
      originX: 'left',
      originY: 'top',
      width: 1,
      height: 1,
      angle: 0,
      strokeLineJoin: IFabric.store.drawStrokeLineCap,
      stroke: this.getStrokeColor(),
      strokeWidth: IFabric.store.drawWidth,
      fill: this.getFillColor(),
      repeat: 'repeat',
      opacity: IFabric.store.drawOpacity,
      selectable: false,
      strokeUniform: IFabric.store.isScaleStroke,
      strokeDashArray: IFabric.store.isDrawStrokeDash
        ? IFabric.store.drawStrokeDash
        : null,
      shadow,
    });
    this.obj.typeShape = 'rect';
    this.canvasF.add(this.obj);
  };
}

export class FabricCircle extends IFabric {
  constructor(canvasF, callback) {
    super(canvasF, callback);
  }

  _mUp = (x, y) => {
    this.obj.setCoords();
  };

  _mMove = (x, y) => {
    let circle = this.obj;
    let radius =
      Math.max(Math.abs(this.origY - y), Math.abs(this.origX - x)) / 2;
    if (radius > circle.strokeWidth) {
      radius -= circle.strokeWidth / 2;
    }
    circle.set({ radius: radius });
    this.obj.set({ left: Math.abs(this.origX > x ? x : this.origX) });
    this.obj.set({ top: Math.abs(this.origY > y ? y : this.origY) });
    // circle.set({ originX: this.origX > x ? 'left' : 'right' });

    // circle.set({ originY: this.origY > y ? 'bottom' : 'top' })
  };

  _mDown = (x, y) => {
    this.id = `${x + y}`;

    const shadow = this.getShadow();
    //_log("fabric.Rect", IFabric.store)
    this.obj = new fabric.Circle({
      id: this.id,
      top: x,
      left: y,
      originX: 'left',
      originY: 'top',
      width: 1,
      radius: x - this.origX,
      height: 1,
      angle: 0,
      strokeLineJoin: IFabric.store.drawStrokeLineCap,
      stroke: this.getStrokeColor(),
      strokeWidth: IFabric.store.drawWidth,
      fill: this.getFillColor(),
      opacity: IFabric.store.drawOpacity,
      selectable: false,
      strokeUniform: IFabric.store.isScaleStroke,
      strokeDashArray: IFabric.store.isDrawStrokeDash
        ? IFabric.store.drawStrokeDash
        : null,
      shadow,
    });
    this.obj.typeShape = 'circle';
    this.canvasF.add(this.obj);
  };
}

export class FabricTriangle extends IFabric {
  constructor(canvasF, callback) {
    super(canvasF, callback);
  }

  _mUp = (x, y) => {
    this.obj.setCoords();
  };

  _mMove = (x, y) => {
    this.obj.set({ left: Math.abs(this.origX > x ? x : this.origX) });
    this.obj.set({ top: Math.abs(this.origY > y ? y : this.origY) });
    this.obj.set({ width: Math.abs(this.origX - x) });
    this.obj.set({ height: Math.abs(this.origY - y) });
  };

  _mDown = (x, y) => {
    this.id = `${x + y}`;

    const shadow = this.getShadow();
    //_log("fabric.Rect", IFabric.store)
    this.obj = new fabric.Triangle({
      id: this.id,
      top: x,
      left: y,
      originX: 'left',
      originY: 'top',
      width: 1,
      height: 1,
      angle: 0,
      strokeLineJoin: IFabric.store.drawStrokeLineCap,
      stroke: this.getStrokeColor(),
      strokeWidth: IFabric.store.drawWidth,
      fill: this.getFillColor(),
      opacity: IFabric.store.drawOpacity,
      selectable: false,
      strokeUniform: IFabric.store.isScaleStroke,
      strokeDashArray: IFabric.store.isDrawStrokeDash
        ? IFabric.store.drawStrokeDash
        : null,
      shadow,
    });
    this.obj.typeShape = 'triangle';
    this.canvasF.add(this.obj);
  };
}

export class FabricPolygon extends IFabric {
  constructor(canvasF, callback) {
    super(canvasF, callback);
    this.points = [];
    this.objs = [];
    this.isFirst = true;
  }

  _mDblClick = (x, y) => {
    //_log("_mDblClick")
    this.id = Date.now();
    const shadow = this.getShadow();

    this.obj = new fabric.Polygon(this.points, {
      id: this.id,
      top: this.points.reduce((previousValue, currentValue) =>
        previousValue.y < currentValue.y ? previousValue : currentValue
      ).y,
      left: this.points.reduce((previousValue, currentValue) =>
        previousValue.x < currentValue.x ? previousValue : currentValue
      ).x,
      strokeLineJoin: IFabric.store.drawStrokeLineCap,
      stroke: this.getStrokeColor(),
      strokeWidth: IFabric.store.drawWidth,
      fill: this.getFillColor(),
      opacity: IFabric.store.drawOpacity,
      selectable: false,
      strokeUniform: IFabric.store.isScaleStroke,
      strokeDashArray: IFabric.store.isDrawStrokeDash
        ? IFabric.store.drawStrokeDash
        : null,
      shadow,
    });
    this.startX = 0;
    this.startY = 0;
    this.points = [];
    this.objs.forEach((o) => {
      this.canvasF.remove(o);
    });
    this.canvasF.add(this.obj);
    //this.obj.setCoords();
    fabric.util.removeListener(window, 'dblclick', this._mDblClick);
    this.isFirst = true;
    this.styleSelection();
  };

  _mUp = (x, y) => {
    this.obj.setCoords();
    this.points.push({ x, y });
  };

  _mMove = (x, y) => {
    this.obj.set({
      x2: x,
      y2: y,
    });
  };

  _mDown = (x, y) => {
    if (this.isFirst) {
      this.isFirst = false;
      fabric.util.addListener(window, 'dblclick', this._mDblClick);
    }
    this.id = `${x + y}`;
    const shadow = this.getShadow();
    if (this.points.length > 0) {
      const lastPoints = this.points.pop();
      x = lastPoints.x;
      y = lastPoints.y;
    }
    this.points.push({ x, y });

    this.obj = new fabric.Line([x, y, x, y], {
      id: this.id,
      strokeLineCap: IFabric.store.drawStrokeLineCap,
      stroke: this.getStrokeColor(),
      strokeWidth: IFabric.store.drawWidth,
      opacity: IFabric.store.drawOpacity,
      selectable: false,
      strokeUniform: IFabric.store.isScaleStroke,
      strokeDashArray: IFabric.store.isDrawStrokeDash
        ? IFabric.store.drawStrokeDash
        : null,
      shadow,
    });
    this.obj.typeShape = 'line';
    this.canvasF.add(this.obj);
    this.objs.push(this.obj);
  };
}

export class FabricBrush extends IFabric {
  ctx;
  constructor(canvasF, callback) {
    super(canvasF, callback);
    this.canvasF.set({ isDrawingMode: true });
    this.ctx = this.canvasF.getContext('2d');
  }

  updateBrush = () => {
    //_log("IFabric.store.typeBrush", IFabric.store.typeBrush)
    const typeBrush = IFabric.store.typeBrush;

    _log('updateBrush', typeBrush);
    if (typeBrush === 'Eraser') {
      this.brush = new fabric.EraserBrush(this.canvasF, { id: Date.now() });
      this.brush.width = IFabric.store.drawWidth;
      this.canvasF.freeDrawingBrush = this.brush;
      this.obj = this.brush;
      this.obj.id = this.id;
      this.obj.objecttype = 'brush';
      this.obj.typeShape = 'brush';
      return;
    } else if (typeBrush === 'vline') {
      this.brush = this.getvLinePatternBrush();
    } else if (typeBrush === 'hline') {
      this.brush = this.gethLinePatternBrush();
    } else if (typeBrush === 'square') {
      this.brush = this.getsquarePatternBrush();
    } else if (typeBrush === 'diamond') {
      this.brush = this.getdiamondPatternBrush();
    } else {
      this.brush = new fabric[IFabric.store.typeBrush + 'Brush'](this.canvasF, {
        id: Date.now(),
      });
    }
    if (IFabric.store.typeBrush === 'Pencil') {
      //this.brush.color = this.getStrokeColor()
      if (IFabric.store.drawBrushRandomColor) {
        this.brush.color = `rgb(${randomNumber(0, 255)},${randomNumber(
          0,
          255
        )},${randomNumber(0, 255)})`;
      } else {
        this.brush.color = this.getStrokeColor();
      }
    } else {
      this.brush.color = IFabric.store.drawStrokeColor;
      if (IFabric.store.drawBrushRandomColor) {
        this.brush.color = `rgb(${randomNumber(0, 255)},${randomNumber(
          0,
          255
        )},${randomNumber(0, 255)})`;
      } else {
        this.brush.color = IFabric.store.drawStrokeColor;
      }
    }

    this.brush.width = IFabric.store.drawWidth;
    this.brush.shadow = window.brushShadow = this.getShadow();
    if (this.brush.getPatternSrc) {
      this.brush.source = this.brush.getPatternSrc.call(this.brush);
    }
    // this.canvasF.freeDrawingBrush = new fabric.CrayonBrush(this.canvasF, {
    //     width: 70,
    //     opacity: 0.6,
    //     color: "#ff0000"
    // });
    this.canvasF.freeDrawingBrush = this.brush;
    //_log(this.brush)
    this.obj = this.brush;
    this.obj.id = Date.now();
    this.obj.objecttype = 'brush';
    this.obj.typeShape = 'brush';
    this.obj.isNotFillable = true;
    this.obj.strokeDashArray = window.strokeDashArray = IFabric.store
      .isDrawStrokeDash
      ? IFabric.store.drawStrokeDash
      : null;
    this.styleSelection();
  };

  _mUp = (x, y) => {
    //_log()
    if (IFabric.store.drawBrushRandomColor) {
      this.updateBrush();
    }
  };

  _mMove = (x, y) => {};

  getvLinePatternBrush = () => {
    const pattern = new fabric.PatternBrush(this.canvasF);
    pattern.getPatternSrc = () => {
      let patternCanvas = fabric.document.createElement('canvas');
      patternCanvas.width = patternCanvas.height = 10;
      let ctx = patternCanvas.getContext('2d');
      //_log("pattern.getPatternSrc")

      if (IFabric.store.drawBrushRandomColor) {
        ctx.strokeStyle = `rgb(${randomNumber(0, 255)},${randomNumber(
          0,
          255
        )},${randomNumber(0, 255)})`;
      } else {
        ctx.strokeStyle = this.getStrokeColor();
      }
      //ctx.lineWidth = IFabric.store.drawWidth;
      ctx.lineWidth = 5;
      ctx.beginPath();
      ctx.moveTo(0, 5);
      ctx.lineTo(10, 5);
      ctx.closePath();
      ctx.stroke();
      return patternCanvas;
    };
    return pattern;
  };

  gethLinePatternBrush() {
    const pattern = new fabric.PatternBrush(this.canvasF);
    pattern.getPatternSrc = () => {
      let patternCanvas = fabric.document.createElement('canvas');
      patternCanvas.width = patternCanvas.height = 10;
      let ctx = patternCanvas.getContext('2d');

      if (IFabric.store.drawBrushRandomColor) {
        ctx.strokeStyle = `rgb(${randomNumber(0, 255)},${randomNumber(
          0,
          255
        )},${randomNumber(0, 255)})`;
      } else {
        ctx.strokeStyle = this.getStrokeColor();
      }
      // ctx.strokeStyle = this.color;
      ctx.lineWidth = 5;
      ctx.beginPath();
      ctx.moveTo(5, 0);
      ctx.lineTo(5, 10);
      ctx.closePath();
      ctx.stroke();
      return patternCanvas;
    };
    return pattern;
  }
  getsquarePatternBrush() {
    const pattern = new fabric.PatternBrush(this.canvasF);
    pattern.getPatternSrc = () => {
      let squareWidth = 10,
        squareDistance = 2;

      let patternCanvas = fabric.document.createElement('canvas');
      patternCanvas.width = patternCanvas.height = squareWidth + squareDistance;
      let ctx = patternCanvas.getContext('2d');

      //ctx.fillStyle = this.getStrokeColor();
      if (IFabric.store.drawBrushRandomColor) {
        ctx.fillStyle = `rgb(${randomNumber(0, 255)},${randomNumber(
          0,
          255
        )},${randomNumber(0, 255)})`;
      } else {
        ctx.fillStyle = this.getStrokeColor();
      }
      ctx.fillRect(0, 0, squareWidth, squareWidth);
      return patternCanvas;
    };
    return pattern;
  }
  getdiamondPatternBrush() {
    const pattern = new fabric.PatternBrush(this.canvasF);
    pattern.getPatternSrc = () => {
      let squareWidth = 10,
        squareDistance = 5;
      let patternCanvas = fabric.document.createElement('canvas');
      let rect = new fabric.Rect({
        width: squareWidth,
        height: squareWidth,
        angle: 45,
        fill: IFabric.store.drawBrushRandomColor
          ? `rgb(${randomNumber(0, 255)},${randomNumber(0, 255)},${randomNumber(
              0,
              255
            )})`
          : this.getStrokeColor(),
      });

      let canvasWidth = rect.getBoundingRect().width;

      patternCanvas.width = patternCanvas.height = canvasWidth + squareDistance;
      rect.set({ left: canvasWidth / 2, top: canvasWidth / 2 });

      let ctx = patternCanvas.getContext('2d');
      rect.render(ctx);
      return patternCanvas;
    };
    return pattern;
  }

  // gettexturePatternBrush() {
  //     //_log("gettexturePatternBrush()", IFabric.store.strokePattern.img)
  //     let texturePatternBrush = new fabric.PatternBrush(this.canvasF);
  //     texturePatternBrush.source = IFabric.store.strokePattern.img;
  //     return texturePatternBrush
  // }

  _mDown = (x, y) => {};
}

export class FabricText extends IFabric {
  constructor(canvasF, callback) {
    super(canvasF, callback);
  }

  _mUp = (x, y) => {};

  _mMove = (x, y) => {};

  _mDown = (x, y) => {
    // if (this.getActiveObjects().length > 0) return
    this.id = `${x + y}`;

    const shadow = this.getShadow();
    //_log("fabric.Line", IFabric.store)
    this.obj = new fabric.IText('', {
      id: this.id,
      top: y,
      left: x,
      objecttype: 'text',
      strokeLineCap: IFabric.store.drawStrokeLineCap,
      stroke: this.getStrokeColor(),
      strokeWidth: IFabric.store.drawWidth,
      opacity: IFabric.store.drawOpacity,
      fill: this.getFillColor(),
      selectable: true,
      editable: true,
      strokeUniform: IFabric.store.isScaleStroke,
      strokeDashArray: IFabric.store.isDrawStrokeDash
        ? IFabric.store.drawStrokeDash
        : null,
      shadow,
    });
    if (IFabric.store.drawTextStyle !== '---') {
      this.obj.set('fontStyle', IFabric.store.drawTextStyle);
    }
    if (IFabric.store.drawTextAlign !== '---') {
      this.obj.set('textAlign', IFabric.store.drawTextAlign);
    }
    if (IFabric.store.drawTextLine !== '---') {
      this.obj.set(IFabric.store.drawTextLine, true);
    } else {
      this.obj.set('underline', false);
      this.obj.set('linethrough', false);
      this.obj.set('overline', false);
    }
    if (IFabric.store.drawFontFamily) {
      this.obj.set('fontFamily', IFabric.store.drawFontFamily);
    }
    if (IFabric.store.drawFontSize) {
      this.obj.set('fontSize', IFabric.store.drawFontSize);
    }
    this.obj.typeShape = 'text';
    this.canvasF.add(this.obj);
    this.canvasF.setActiveObject(this.obj);
    //this.remove()
    // //sore.setValue("typeShape", "---")
    //store.setValue("typeShape", "---");
    // //this.setTypeShape("---")
    this.obj.enterEditing();

    //this.setSelectable()
    this.styleSelection();
  };
}

export class FabricImage extends IFabric {
  constructor(canvasF, callback, file, filterCSS, filters) {
    super(canvasF, callback);
    this.filterCSS = filterCSS;
    this.filters = filters;
    this.initImage(file);
  }

  applyFilters = (img, newWidth, newHeight) => {
    return new Promise((resolve, reject) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = newWidth;
      canvas.height = newHeight;
      const _img = new Image();
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      _img.src = canvas.toDataURL();
      //_log("this.filterCSS", this.filterCSS)
      if (this.filterCSS) {
        ctx.filter = this.filterCSS;
      }
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      //ImageFilters.applyFilters(canvas, ctx, this.filters, false, true);
      const dataURL = canvas.toDataURL();
      const newImage = new Image();
      newImage.onload = () => {
        resolve({ _img, newImage });
      };
      newImage.src = dataURL;
    });
  };

  initImage = async (file) => {
    let b64 = file;
    if (typeof file !== 'string') {
      b64 = await toBase64(file);
    }
    const img = new Image();
    let newWidth = this.canvasF.width;
    let newHeight = this.canvasF.height;
    img.onload = async () => {
      if (img.width < newWidth) {
        newWidth = img.width;
        newHeight = img.height;
      } else {
        newWidth = this.canvasF.width - 40;
        newHeight = ratioHeight(img.width, img.height, newWidth);
      }
      const { _img, newImage } = await this.applyFilters(
        img,
        newWidth,
        newHeight
      );
      this.image = newImage;
      this.obj.typeShape = 'image';
      this.obj = new fabric.Image(newImage, {
        id: this.id,
        left: 20,
        top: 60,
        angle: 0,
        selectable: true,
        selected: true,
        active: true,
        opacity: IFabric.store.opacityImage,
        width: newWidth,
        height: newHeight,
        objecttype: 'image',
      });
      //_log("initImage()")
      this.obj.img = newImage;
      this.obj.setOverlay = this.setOverlay.bind(this);
      this.obj.setBackground = this.setBackground.bind(this);
      this.obj.isNotFillable = true;
      this.canvasF.add(this.obj);
      if (this.callback) {
        this.callback(this.obj);
      }
      this.styleSelection();
      this.canvasF.setActiveObject(this.obj);
    };
    img.src = b64;
  };

  setOverlay = async (v) => {
    //_log("setOverlay()")
    if (!v) {
      this.obj.setElement(this.image);
    } else {
      this.overlay = (await imgResize(v, this.w)).img;
      this.obj.setElement(this.overlay);
    }
  };

  setBackground = async (v) => {
    //_log("setBackground()")
    let img;
    if (v) {
      this.canvas = document.createElement('canvas');
      this.canvas.width = this.w;
      this.canvas.height = this.h;
      img = (await imgResize(v, this.w)).img;
      this.canvas.drawImage(img, 0, 0, this.canvas.width, this.canvas.height);
    } else {
      img = null;
      this.obj.setElement(this.image);
      return;
    }
    const state = true;
    this.selfieSegmentation = new SelfieSegmentation({
      locateFile: (file) => {
        return `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`;
      },
    });
    this.selfieSegmentation.setOptions({
      modelSelection: 1,
    });
    this.selfieSegmentation.onResults(async (results) => {
      //_log("onResults")
      const canvasCtx = this.canvas.getContext('2d');
      const canvasElement = this.canvas;
      canvasCtx.clearRect(0, 0, canvasElement.width, canvasElement.height);
      canvasCtx.drawImage(
        results.segmentationMask,
        0,
        0,
        canvasElement.width,
        canvasElement.height
      );
      if (state == false) canvasCtx.globalCompositeOperation = 'source-in';
      else canvasCtx.globalCompositeOperation = 'source-out';

      canvasCtx.drawImage(img, 0, 0, canvasElement.width, canvasElement.height);
      canvasCtx.globalCompositeOperation = 'destination-atop';
      canvasCtx.drawImage(
        results.image,
        0,
        0,
        canvasElement.width,
        canvasElement.height
      );

      this.obj.setElement(this.canvas);
    });
    this.selfieSegmentation.send({ image: this.canvas });
  };

  _mUp = (x, y) => {};

  _mMove = (x, y) => {};

  _mDown = (x, y) => {};
}
